import { toast } from "$global-providers/toast-provider";
import { useCallback } from "react";

interface Options {
  autoHideDuration?: number;
  forceUserToClose?: boolean;
}

function mapOptionsToToastOptions(options?: Options) {
  return {
    duration: options?.forceUserToClose ? Infinity : options?.autoHideDuration,
  };
}

/**
 * @deprecated
 * Use instead:
 * import toast from 'elephant-web/components/mui/toast'
 * toast.success('Foo')
 */
export function useEmitSuccessNotification() {
  return useCallback((message: string, options?: Options) => {
    toast.success(message, mapOptionsToToastOptions(options));
  }, []);
}

/**
 * @deprecated
 * Use instead:
 * import toast from 'elephant-web/components/mui/toast'
 * toast.error('Foo')
 */
export function useEmitErrorNotification() {
  return useCallback((message: string, options?: Options) => {
    toast.error(message, mapOptionsToToastOptions(options));
  }, []);
}

export function useEmitNotification() {
  const emitSuccessNotification = useEmitSuccessNotification();
  const emitErrorNotification = useEmitErrorNotification();
  return {
    emitSuccessNotification,
    emitErrorNotification,
  };
}
